import React, { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import styles from "./notFound.module.css";
import SearchLayout from "../layout/searchLayout";

const FUNNY_MESSAGES = [
  "The page you're looking for is in another castle.",
  "404: Page not found. But you found this message, so that's something.",
  "This page went out for coffee and never came back.",
  "Looks like this page took a wrong turn at Albuquerque.",
  "Error 404: The hamster powering this page fell off the wheel.",
  "This page has been abducted by aliens. We're negotiating its return.",
  "You've reached the edge of the internet. Please turn back.",
  "The page you requested has moved to a secret location. Clue: it doesn't exist.",
];

function NotFound() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const suggestion = searchParams.get("suggest") || "";
  const suggestUrl = searchParams.get("to") || "";

  const funnyMessage = useMemo(
    () => FUNNY_MESSAGES[Math.floor(Math.random() * FUNNY_MESSAGES.length)],
    []
  );

  const displayQuery = query || window.location.pathname.replace(/^\//, "");

  return (
    <SearchLayout containerClassName={`all-results-container ${styles.page}`}>
      {suggestion && suggestUrl ? (
        <div className={styles.suggest}>
          <p>Did you mean:</p>
          <div className={styles.suggestions}>
            <Link to={suggestUrl} className={styles.suggestionLink}>
              {suggestion}
            </Link>
          </div>
        </div>
      ) : (
        <div className={styles.suggest}>
          <p>Did you mean:</p>
          <div className={styles.suggestions}>
            <Link to="/about">about</Link>
            <Link to="/experience">experience</Link>
            <Link to="/projects">projects</Link>
            <Link to="/resume">resume</Link>
            <Link to="/email">email</Link>
          </div>
        </div>
      )}

      <div className={styles.details}>
        <p className={styles.funnyMsg}>{funnyMessage}</p>
        <p>
          Your search - <b>{displayQuery}</b> - did not match any documents.
        </p>
        <p>Suggestions:</p>
        <ul>
          <li>Try a different keyword from the search dropdown</li>
          <li>Make sure that all words are spelled correctly</li>
          <li>Click one of the links from the suggestions or menu above</li>
        </ul>
      </div>

      <iframe
        src={`${process.env.PUBLIC_URL}/dino.html`}
        title="T-Rex Runner"
        className={styles.dinoFrame}
      />
    </SearchLayout>
  );
}

export default NotFound;
